module.exports = __webpack_public_path__ + "fourCover.d2ec0f0cea06afb73992.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/four/fourCover.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/four/fourCover.jpg
// module chunks = 0